import { gql } from '@apollo/client';

const queryGetEnvShareRequest = ({ filter }) => {
    return {
        variables: {
            filter: filter,
        },
        query: gql`
            query ListEnvironments($filter: EnvironmentFilter) {
                listEnvironments(filter: $filter) {
                    nodes {
                        environmentUri
                        label
                        AwsAccountId
                        AwsProdAccountId
                        AwsDevAccountId
                        AwsTestAccountId
                        AwsToolAccountId
                        AwsValAccountId
                    }
                }
            }
        `,
    };
};

export default queryGetEnvShareRequest;
